import { useState } from "react";
import {
  Box,
  IconButton,
  Button,
  Fade,
  Stack,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

export const MenuOverlay = ({ onHowItWorks, onFaqs, onDownloadApp, initialOpen = false, onOpen, onClose, disabled = false }) => {
  const [isVisible, setIsVisible] = useState(initialOpen);

  const handleFeedback = () => {
    window.open("https://www.pixlbank.com/feedback", "_blank");
  };

  const handleToggle = () => {
    if (!isVisible) {
      onOpen?.()
    } else {
      onClose?.()
    }
    setIsVisible((prev) => !prev)
  };

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1000,
        pointerEvents: "none",
        backgroundColor: isVisible ? "rgba(0, 0, 0, 0.7)" : "transparent",
        transition: "background-color 0.3s ease",
      }}
    >
      {/* Hamburger / X button - top right */}
      <Box
        sx={{
          position: "absolute",
          top: 12,
          right: 12,
          pointerEvents: "all",
        }}
      >
        <IconButton
          onClick={handleToggle}
          disabled={disabled}
          sx={{
            width: 50,
            height: 50,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            color: "white",
            borderRadius: "50%",
            boxShadow: "0 2px 8px rgba(0,0,0,0.4)",
            opacity: disabled ? 0.4 : 1,
            transition: "opacity 0.3s ease",
            "&.Mui-disabled": {
              color: "white",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            },
            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          }}
        >
          {isVisible ? <CloseIcon /> : <MenuIcon />}
        </IconButton>
      </Box>

      {/* Menu items */}
      <Fade in={isVisible}>
        <Stack
          spacing={2}
          sx={{
            position: "absolute",
            top: 140,
            right: 30,
            alignItems: "flex-end",
            pointerEvents: isVisible ? "all" : "none",
          }}
        >
          {[
            { label: "How It Works", onClick: onHowItWorks },
            { label: "FAQs", onClick: onFaqs },
            { label: "Download App", onClick: onDownloadApp },
            { label: "Feedback", onClick: handleFeedback },
          ].map((item) => (
            <Button
              key={item.label}
              onClick={item.onClick}
              sx={{
                color: "white",
                fontSize: "1.75rem",
                textTransform: "none",
                padding: "8px 0",
                minWidth: 0,
                "&:hover": {
                  backgroundColor: "transparent",
                  opacity: 0.7,
                },
              }}
            >
              {item.label}
            </Button>
          ))}
        </Stack>
      </Fade>
    </Box>
  );
};